// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"70":"npm.regenerator-runtime","153":"npm.url-polyfill","785":"npm.whatwg-fetch","912":"npm.core-js"}[chunkId] || chunkId) + ".js";
};